import React from "react";

import { EMPTY_STRING } from "../../../constants";
import DropdownSkeleton from "../../Skeletons/DropdownSkeleton/DropdownSkeleton";
import TitleToolTip from "../toolTipComponent/TitleToolTip";

const CustomCellRendererWithSkeleton = (props) => {
  const {
    params,
    cellComponent,
    cellComponentClassName = EMPTY_STRING,
    componentRenderCondition = params?.data?.id,
    titleToolTipText = EMPTY_STRING, // Can be used in both table libraries 1. Ag Grid 2. react-data-table-component. When using this component in ag grid use the ag grid's built in tool tip not this prop (use the following prop in column defination for table header tool tip "headerToolTip", and "tooltipValueGetter"/"tooltipField" for cell tool tip, BUT IT WILL SHOW THE DEFAULT VALUE WHILE THE DATA IS LOADING, SO FOR SERVER PAGINATION TABLE WE CAN USE THIS PROPS)
  } = props;
  const RenderComponent = () =>
    titleToolTipText && titleToolTipText.length ? (
      <TitleToolTip
        title={titleToolTipText}
        children={cellComponent}
        childrenClassName={cellComponentClassName}
        isTitleTextElipsis={true}
        isWrapChildren={true}
      />
    ) : typeof cellComponent === "string" ? (
      <span className={`text-truncate ${cellComponentClassName}`}>
        {cellComponent}
      </span>
    ) : (
      <div className={`text-truncate ${cellComponentClassName}`}>
        {cellComponent}
      </div>
    );

  return componentRenderCondition ? (
    <RenderComponent />
  ) : (
    <DropdownSkeleton width="5em" height="1.5em" />
  );
};

export default CustomCellRendererWithSkeleton;
